"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEnterOrSpace = _interopRequireDefault(require("../../../../shared/helpers/isEnterOrSpace"));

var _iconClose = _interopRequireDefault(require("../../../../shared/icons/icon-close.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ExpandableCard = /*#__PURE__*/function (_Component) {
  _inherits(ExpandableCard, _Component);

  var _super = _createSuper(ExpandableCard);

  function ExpandableCard(props) {
    var _this;

    _classCallCheck(this, ExpandableCard);

    _this = _super.call(this, props);
    _this.state = {
      showInfo: false
    };
    _this.toggleShowInfo = _this.toggleShowInfo.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ExpandableCard, [{
    key: "toggleShowInfo",
    value: function toggleShowInfo() {
      var newState = this.state;
      var showInfo = !newState.showInfo;
      this.setState({
        showInfo: showInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$cardItem = _this$props.cardItem,
          cardTitle = _this$props$cardItem.card_title,
          cardImage = _this$props$cardItem.card_image,
          cardBody = _this$props$cardItem.card_body,
          dataClient = _this$props.dataClient;
      var showInfo = this.state.showInfo;
      var infoClass = (0, _classnames["default"])({
        'content-page__expandable-card-info-hide': !showInfo,
        'content-page__expandable-card-info-show': showInfo
      });
      var closeClass = (0, _classnames["default"])({
        'content-page__expandable-card-close-hide': !showInfo,
        'content-page__expandable-card-close-show': showInfo
      });
      var mainClass = (0, _classnames["default"])({
        'content-page__expandable-card-main-show': !showInfo,
        'content-page__expandable-card-main-blur': showInfo
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "content-page__expandable-card"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        title: "Close",
        className: closeClass,
        type: "button",
        onClick: this.toggleShowInfo,
        onKeyPress: function onKeyPress(event) {
          return (0, _isEnterOrSpace["default"])(event) && _this2.toggleShowInfo;
        }
      }, /*#__PURE__*/_react["default"].createElement(_iconClose["default"], {
        className: "content-page__expandable-card-close-icon"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: mainClass
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "content-page__expandable-card-title"
      }, dataClient.textToMarkdown(cardTitle)), /*#__PURE__*/_react["default"].createElement("img", {
        className: "content-page__expandable-card-image",
        src: cardImage.url,
        alt: "".concat(dataClient.renderText(cardTitle))
      }), /*#__PURE__*/_react["default"].createElement("button", {
        className: "content-page__expandable-card-button",
        type: "button",
        onClick: this.toggleShowInfo,
        onKeyPress: function onKeyPress(event) {
          return (0, _isEnterOrSpace["default"])(event) && _this2.toggleShowInfo;
        }
      }, "Learn More")), /*#__PURE__*/_react["default"].createElement("div", {
        className: infoClass
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "content-page__expandable-card-text"
      }, dataClient.renderFullMarkup(cardBody))));
    }
  }]);

  return ExpandableCard;
}(_react.Component);
/* eslint-disable camelcase */


ExpandableCard.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  cardItem: _propTypes["default"].shape({
    card_body: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
    card_image: _propTypes["default"].shape({}).isRequired,
    card_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
  }).isRequired
};
var _default = ExpandableCard;
exports["default"] = _default;